import { InsuranceStatus } from '../../../../constants';

export const getTherapyStatusMsg = ({
  isCompanyHpiEnabled,
  memberInsuranceStatus,
}: {
  isCompanyHpiEnabled: boolean;
  memberInsuranceStatus: string;
}) => {
  if (!isCompanyHpiEnabled) return 'No sessions left';

  switch (memberInsuranceStatus) {
    case InsuranceStatus.ELIGIBLE:
      return `HPI ${InsuranceStatus.ELIGIBLE}`;
    default:
      return memberInsuranceStatus;
  }
};
